// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__3qMcx","smallIcon":"styles_smallIcon__2LMXx"};